import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment';
import { diffrenceBetweenTwoDates, getDiffrenceInDays } from './commonFunctions';

const HEADER_MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

const YearGrid = ({ currentYear, onSelect }) => {
  const [start, setStart] = React.useState(currentYear - 12);
  const years = [];
  for (let i = 0; i < 24; i++) years.push(start + i);
  return (
    <div className='custom-year-grid-popup'>
      <div className='custom-year-grid-header'>
        <button type='button' onClick={() => setStart(start - 24)} title='Previous 24 years'>&lsaquo;</button>
        <span>{years[0]} – {years[23]}</span>
        <button type='button' onClick={() => setStart(start + 24)} title='Next 24 years'>&rsaquo;</button>
      </div>
      <div className='custom-year-grid'>
        {years.map((y) => (
          <button
            key={y}
            type='button'
            className={'custom-year-cell' + (y === currentYear ? ' selected' : '')}
            onClick={() => onSelect(y)}
          >
            {y}
          </button>
        ))}
      </div>
    </div>
  );
};

const CalendarHeader = ({ date, changeYear, changeMonth, decreaseMonth, increaseMonth }) => {
  const [showYearGrid, setShowYearGrid] = React.useState(false);
  const year = date.getFullYear();
  const month = date.getMonth();
  const handlePickYear = (y) => {
    changeYear(y);
    setShowYearGrid(false);
  };
  return (
    <div className='custom-rdp-header'>
      <button type='button' className='custom-rdp-step' onClick={decreaseMonth} title='Previous month'>&lsaquo;</button>
      <select className='custom-rdp-select' value={month} onChange={(e) => changeMonth(parseInt(e.target.value, 10))}>
        {HEADER_MONTHS.map((m, i) => <option key={m} value={i}>{m}</option>)}
      </select>
      <button
        type='button'
        className='custom-rdp-year-btn'
        onClick={() => setShowYearGrid((s) => !s)}
      >
        {year} <span className='custom-rdp-caret'>&#9662;</span>
      </button>
      <button type='button' className='custom-rdp-step' onClick={increaseMonth} title='Next month'>&rsaquo;</button>
      {showYearGrid && (
        <YearGrid currentYear={year} onSelect={handlePickYear} />
      )}
    </div>
  );
};

const CustomDatetimepicker = (props) => {
  function handleChange(datetime) {
    props.setField(props.fieldname, datetime)

    if (props?.correspondingEndDate) {
      const totalDays = diffrenceBetweenTwoDates(
        datetime,
        props.correspondingEndDate,
      )
      if (totalDays <= 0) {
        props.formikRef?.current?.setFieldValue(props.correspondingEndDateName, null)
      }
    }
    setTimeout(() => {
      if (props?.formikRef?.current?.values?.hotelStartDate && props?.formikRef?.current?.values.hotelEndDate) {
        const totalDays = getDiffrenceInDays(
          props?.formikRef?.current?.values?.hotelStartDate,
          props?.formikRef?.current?.values.hotelEndDate
        )

        const addedDays = totalDays + 1;
        if (addedDays > 0) {
          var newDates = [];
          newDates.push({
            id: 0,
            totalQuantitySingleRoom: "",
            priceSingleRoom: "",
            breakfastPriceSingleRoom: "",
            totalQuantityDoubleRoom: "",
            priceDoubleRoom: "",
            breakfastPriceDoubleRoom: "",
            date: props?.formikRef?.current?.values?.hotelStartDate.toISOString().split("T")[0],
            checkforSingleRoom: true,
            checkforDoubleRoom: true
          });
          var date1 = new Date(props?.formikRef?.current?.values?.hotelStartDate);
          for (let i = 1; i < addedDays; i++) {
            const tomorrow = new Date(date1);
            tomorrow.setDate(date1.getDate() + 1)
            newDates.push({
              id: i,
              totalQuantitySingleRoom: "",
              priceSingleRoom: "",
              breakfastPriceSingleRoom: "",
              totalQuantityDoubleRoom: "",
              priceDoubleRoom: "",
              breakfastPriceDoubleRoom: "",
              date: tomorrow.toISOString().split("T")[0],
              checkforSingleRoom: true,
              checkforDoubleRoom: true
            });
            date1 = tomorrow;
          }
          props.formikRef?.current?.setFieldValue("hotelTotalDays", newDates);
        }
      }
    }, 500)
  }

  const handleBlur = () => {
    props.setFieldTouched(props.fieldname, true)
  };

  const filterDate = (current) => {
    if (props && props?.endDate) {
      if (props && props?.correspondingStartDate) {
        return !moment(current).isBefore(props?.correspondingStartDate, 'day');
      }
      return !(moment().add(-1, 'days') >= moment(current));
    }
    return !(moment().add(-1, 'days') >= moment(current));
  }

  const renderHeader = (headerProps) => <CalendarHeader {...headerProps} />;

  return (
    <div className='custom-datepicker-wrap col-md6'>
      <DatePicker
        disabled={props.disabled ? props.disabled : false}
        selected={props.value ? new Date(props.value) : null}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholderText={props.placeholder ? props.placeholder : "YYYY-MM-DD"}
        dateFormat="yyyy-MM-dd"
        className='form-control'
        wrapperClassName='custom-datepicker-input-wrap'
        calendarClassName='custom-datepicker-calendar'
        popperClassName='custom-datepicker-popper'
        isClearable={true}
        renderCustomHeader={renderHeader}
        filterDate={filterDate}
        autoComplete='off'
        popperPlacement='bottom-start'
        popperProps={{ strategy: 'fixed' }}
      />
    </div>
  )
}

export default CustomDatetimepicker
